import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'app-misalignment-factor',
    templateUrl: './misalignment-factor.component.html',
    styleUrls: ['./misalignment-factor.component.scss'],
    standalone: false
})
export class MisalignmentFactorComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Output() selected: EventEmitter<number> = new EventEmitter();

    tooltip_position = 'above';

    optionList = new Map([
        ['None', 1],
        ['1.5 x', 1.5],
        ['2 x', 2],
    ]);

    ngOnInit(): void {
        this.form.markAllAsTouched();
        if (this.form.get('misalignmentFactor').value) {
            this.form.get('misalignmentFactor').setValue(this.form.get('misalignmentFactor').value);
        }
    }

    private selectMisalignmentFactor(selectedValue: MatSelectChange): void {
        const selection = this.optionList.get(selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
        }
    }
}
